import { useLocation } from 'react-router-dom';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped dep
import IFrame from 'ui-addon-iframeable/host/IFrame';
import { IframeLayout } from '../components/layouts/IframeLayout';
import { useIsMobileView } from '../hooks/useWindowSize';
import { ROUTES } from '../components/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ViewInvoice() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const invoiceUrl = params.get('url');
  const isMobileView = useIsMobileView();
  return /*#__PURE__*/_jsx(IframeLayout, {
    backButtonMessage: "viewInvoice.backButton",
    breadcrumbs: [{
      label: 'viewInvoice.breadcrumb.billing',
      href: ROUTES.billing
    }, {
      label: 'viewInvoice.breadcrumb.payInvoice'
    }],
    subscreen: "view-invoice",
    children: invoiceUrl && /*#__PURE__*/_jsxs(View, {
      marginInline: isMobileView ? '0' : '1400',
      paddingBlockStart: "1000",
      paddingBlockEnd: isMobileView ? '1000' : '1500',
      backgroundColor: "fill-surface-default",
      children: [/*#__PURE__*/_jsx(Text, {
        marginInlineStart: "800",
        typography: "heading-600",
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "viewInvoice.heading"
        })
      }), /*#__PURE__*/_jsx(IFrame, {
        src: invoiceUrl,
        onReady: () => {},
        iframePassthruProps: {
          style: {
            border: 'none',
            marginInline: isMobileView ? '0' : '5%',
            width: isMobileView ? '100%' : '90%',
            height: 'calc(100vh - 400px)'
          },
          title: 'Invoice'
        }
      })]
    })
  });
}